import "@babel/polyfill";

// Core
import 'popper.js';
import 'bootstrap';

import './js/core';
import './js/menu';
import './js/components';

// IE SVG fix
if(/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
	require('svgxuse');
	require('objectFitPolyfill/dist/objectFitPolyfill.min');
	require('classlist-polyfill/src/index');
	objectFitPolyfill();
}
